import { MedicineSimilar } from '@dreryk/egabinet-prescription-frontend-api';
import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { StyledFlex, Table, Text } from '@dreryk/react-components';
import { useTranslate } from '@dreryk/react-common';

import { VisitDiagnoses } from '~libs.shared.visit';
import { isEmpty } from '~libs.typescript';

import { medicineTranslationKeys } from '../../../../../../../translations';

import {
   useMedicineSimilarDataConfiguration,
   useMedicineSimilarTableColumnConfiguration,
} from './MedicineSimilarTable.hooks';
import { MedicineSearchDataAccessor, medicineSearchKeyExtractor } from './MedicineSimilarTable.utils';

export type MedicineSimilarTableProps = {
   patientId: Patient['id'];
   withdrawnMedicineId: number;
   onMedicineSelection: (medicine: MedicineSimilar) => void;
   visitDiagnoses: VisitDiagnoses;
};

export const MedicineSimilarTable = (props: MedicineSimilarTableProps): JSX.Element => {
   const translate = useTranslate();
   const dataConfiguration = useMedicineSimilarDataConfiguration(props.patientId, props.withdrawnMedicineId);
   const columns = useMedicineSimilarTableColumnConfiguration({
      patientId: props.patientId,
      onMedicineSelection: props.onMedicineSelection,
      visitDiagnoses: props.visitDiagnoses,
   });

   const noDataAvailable = isEmpty(dataConfiguration.dataPart?.data);

   return (
      <StyledFlex direction={'column'} gap={'8px'}>
         {noDataAvailable ? null : (
            <StyledFlex gap={'6px'} alignItems={'center'}>
               <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                     d='M4.4 21L3 19.6L10.525 12.05L6 10.925L10.95 7.85L10.525 2L15 5.775L20.4 3.575L18.225 9L22 13.45L16.15 13.05L13.05 18L11.925 13.475L4.4 21ZM5 8L3 6L5 4L7 6L5 8ZM13.875 12.925L15.075 10.95L17.4 11.125L15.9 9.35L16.775 7.2L14.625 8.075L12.85 6.6L13.025 8.9L11.05 10.125L13.3 10.675L13.875 12.925ZM18 21L16 19L18 17L20 19L18 21Z'
                     fill='url(#paint0_linear_1951_17187)'
                  />
                  <defs>
                     <linearGradient
                        id='paint0_linear_1951_17187'
                        x1='-6.5'
                        y1='11.5'
                        x2='12.5'
                        y2='30.5'
                        gradientUnits='userSpaceOnUse'
                     >
                        <stop stopColor='#0B9A84' />
                        <stop offset='1' stopColor='#31448A' />
                     </linearGradient>
                  </defs>
               </svg>
               <Text testId={'medicineSimilar'}>{translate(medicineTranslationKeys.replacement.medicinesSimilar)}</Text>
            </StyledFlex>
         )}
         <Table<MedicineSimilar>
            testId={'medicineSearch'}
            dataConfiguration={dataConfiguration}
            columns={columns}
            keyExtractor={medicineSearchKeyExtractor}
            dataAccessor={MedicineSearchDataAccessor}
         />
      </StyledFlex>
   );
};
